module.exports = __webpack_public_path__ + "users-group.4994520759d109a54d167808d07889ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/users-group.svg
// module id = 1162
// module chunks = 0